/* ============================================================
   JOWI — popup-ghl.js (portado de Lindo, 04/10/2026)
   Adapter para enviar leads de popups según settings.email_provider.
   Soporta: GHL webhook, Klaviyo Subscribe API, Mailchimp embed,
   y Shopify customer form como fallback.
   ============================================================ */
(function () {
  'use strict';

  const CONFIG = window.ShopThemeConfig || {};

  async function submitGHL(popupId, payload) {
    const url = CONFIG.ghlEndpoint;
    if (!url) {
      console.warn('[popup-ghl] No GHL endpoint configured');
      return submitShopify(popupId, payload);
    }
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        source: payload.source || `popup-${popupId}`,
        email: payload.email,
        firstName: payload.firstName || '',
        phone: payload.phone || '',
        tags: (payload.tags || '').split(',').map((t) => t.trim()).filter(Boolean),
        // La casilla «gdpr» es el consentimiento de EMAIL (su texto no nombra los SMS).
        consent: { email: payload.gdpr === 'on' },
        // JOWI 01 (n8n) lee estos dos: el popup es una alta de NOVEDADES, no un aviso de talla.
        formulario: 'newsletter',
        consent_email: payload.gdpr === 'on',
        page_url: location.href,
        // Cookies de Meta (04/10/2026): van con el Lead a la CAPI.
        fbp: (document.cookie.match(/(?:^|; )_fbp=([^;]*)/) || [])[1] || '',
        fbc: (document.cookie.match(/(?:^|; )_fbc=([^;]*)/) || [])[1] || (new URLSearchParams(location.search).get('fbclid') ? 'fb.1.' + Date.now() + '.' + new URLSearchParams(location.search).get('fbclid') : ''),
        locale: document.documentElement.lang,
        // visitor_id del script de push (JOWI aún no tiene push): n8n fusiona el contacto anónimo con este.
        visitor_id: (function () { try { return localStorage.getItem('jowi_visitor_id') || ''; } catch (e) { return ''; } })(),
        customFields: {
          popup_id: popupId,
          discount_code: payload.discount_code || '',
          quiz_answers: collectQuizAnswers(payload),
          locale: document.documentElement.lang,
          country: (window.Shopify && window.Shopify.country) || ''
        }
      })
    });
    // Sin 'no-cors': la respuesta se lee de verdad. Antes SIEMPRE devolvia ok
    // aunque GHL no hubiera recibido nada, y el fallo era invisible.
    if (!res.ok) throw new Error('webhook GHL ' + res.status);
    // n8n contesta 200 aunque GHL rechace el contacto: hay que leer "ok".
    const data = await res.json().catch(() => null);
    const r = Array.isArray(data) ? data[0] : data;
    if (r && r.ok === false) throw new Error('GHL rechazó el contacto: ' + (r.error || ''));
    return r || { ok: true };
  }

  async function submitKlaviyo(popupId, payload) {
    const listId = CONFIG.klaviyoListId;
    const apiKey = CONFIG.klaviyoPublicKey;
    if (!listId || !apiKey) {
      console.warn('[popup-ghl] Klaviyo not configured, falling back');
      return submitShopify(popupId, payload);
    }
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${apiKey}`;
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: `popup-${popupId}`,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: payload.email,
                phone_number: payload.phone || undefined,
                first_name: payload.firstName || undefined,
                properties: { popup_id: popupId, discount_code: payload.discount_code || '' }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(`Klaviyo error ${res.status}`);
    return res.json().catch(() => ({ ok: true }));
  }

  async function submitMailchimp(popupId, payload) {
    const url = CONFIG.mailchimpActionUrl;
    if (!url) return submitShopify(popupId, payload);
    const fd = new FormData();
    fd.append('EMAIL', payload.email);
    if (payload.firstName) fd.append('FNAME', payload.firstName);
    if (payload.phone) fd.append('PHONE', payload.phone);
    // Mailchimp embed forms require a hidden honeypot field — server-side
    await fetch(url, { method: 'POST', body: fd, mode: 'no-cors' });
    return { ok: true };
  }

  async function submitShopify(popupId, payload) {
    // Fallback: Shopify customer endpoint via standard form
    const fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', payload.email);
    fd.append('contact[tags]', (payload.tags || '') + `,popup-${popupId},newsletter`);
    if (payload.firstName) fd.append('contact[first_name]', payload.firstName);
    if (payload.phone) fd.append('contact[phone]', payload.phone);

    const res = await fetch('/contact#contact_form', { method: 'POST', body: fd });
    return { ok: res.ok };
  }

  function collectQuizAnswers(payload) {
    const out = {};
    Object.keys(payload).forEach((k) => {
      if (k.startsWith('q')) out[k] = payload[k];
    });
    return out;
  }

  window.ShopThemePopupAPI = {
    submit(provider, popupId, payload) {
      try {
        switch ((provider || 'none').toLowerCase()) {
          case 'ghl': return submitGHL(popupId, payload);
          case 'klaviyo': return submitKlaviyo(popupId, payload);
          case 'mailchimp': return submitMailchimp(popupId, payload);
          default: return submitShopify(popupId, payload);
        }
      } catch (err) {
        console.error('[popup-ghl]', err);
        return submitShopify(popupId, payload);
      }
    }
  };
})();
